import { render, staticRenderFns } from "./salesOrderEdit_ec.vue?vue&type=template&id=06b2d852&scoped=true&"
import script from "./salesOrderEdit_ec.vue?vue&type=script&lang=js&"
export * from "./salesOrderEdit_ec.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderEdit_ec.vue?vue&type=style&index=0&id=06b2d852&lang=less&scoped=true&"
import style1 from "./salesOrderEdit_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2d852",
  null
  
)

component.options.__file = "salesOrderEdit_ec.vue"
export default component.exports